import { Icon, IconButton, SxProps, Theme, Tooltip } from '@mui/material';
import React from 'react';

type ActionButtonProps = {
    title: string;
    onClick: () => void;
    disabled?: boolean;
    sx?: SxProps<Theme>;
    icon: string;
    hide?: boolean;
};

const ActionButton: React.FC<ActionButtonProps> = ({
    title,
    onClick,
    icon,
    disabled = false,
    hide = false,
    sx
}) => {
    if (hide) return <></>

    return disabled ? (<>
        <IconButton
            disabled
            size="small"
            color="primary"
            onClick={onClick}
            sx={(theme) => ({
                sx,
                mixBlendMode: theme.palette.mode === 'dark' ? 'soft-light' : 'normal'
            })}
        >
            <Icon>
                {icon}
            </Icon>
        </IconButton >
    </>) : (<>
        <Tooltip title={title} >
            <IconButton
                size="small"
                color="primary"
                onClick={onClick}
                sx={sx}
            >
                <Icon>
                    {icon}
                </Icon>
            </IconButton>
        </Tooltip >


    </>)
};

export default ActionButton;
